/* Prove the remaining live tail before removing links. A restock needs no rank sync. */
(() => {
  if (window.__lmmStockPagination) return;
  window.__lmmStockPagination = true;
  async function init() {
    const marker = document.querySelector('[data-lmm-stock-pagination]');
    if (!marker || marker.dataset.checked || marker.dataset.sort !== 'manual') return;
    const cur = Number(marker.dataset.page), size = Number(marker.dataset.size);
    const count = Number(marker.dataset.buyable), pageCount = Number(marker.dataset.pageCount);
    // A full current page cannot establish a boundary. Keep native navigation.
    if (count === pageCount && count > 0) return;
    marker.dataset.checked = '1';
    const root = marker.closest('.lmm-coll');
    if (!root || !(size > 0) || !(cur > 0)) return;
    const pageUrl = new URL(location.href);
    const firstIndexPage = Math.floor(((cur - 1) * size) / 250) + 1;
    async function read(page) {
      const url = new URL(pageUrl);
      url.searchParams.set('section_id', 'lmm-collection-availability');
      url.searchParams.delete('sections');
      url.searchParams.set('page', String(page));
      const response = await fetch(url, {signal: AbortSignal.timeout(10000)});
      if (!response.ok) throw new Error('Availability HTTP');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const node = doc.querySelector('[data-lmm-availability-index]');
      if (!node) throw new Error('Availability section missing');
      const data = JSON.parse(node.textContent);
      if (data.page !== page || data.offset !== (page - 1) * 250 || !Array.isArray(data.items) ||
          data.items.some(x => x !== 0 && x !== 1)) throw new Error('Availability schema');
      return data;
    }
    try {
      const first = await read(firstIndexPage);
      const pages = [first];
      // Finite content pagination, each later page fetched ONCE, no status polling.
      for (let start = firstIndexPage + 1; start <= first.pages; start += 3) {
        const batch = [];
        for (let p = start; p <= Math.min(start + 2, first.pages); p++) batch.push(read(p));
        pages.push(...await Promise.all(batch));
      }
      if (!marker.isConnected || location.href !== pageUrl.href) return;
      if (pages.some(p => p.total !== first.total || p.pages !== first.pages) ||
          pages.reduce((n,p) => n + p.items.length, 0) !== first.total - first.offset) return;
      const availablePages = new Set();
      let currentCount = 0;
      for (const p of pages) p.items.forEach((available, i) => {
        const displayPage = Math.floor((p.offset + i) / size) + 1;
        if (available) availablePages.add(displayPage);
        if (available && displayPage === cur) currentCount++;
      });
      // If inventory changed since the current HTML, do not hide anything based on mixed reads.
      if (currentCount !== count) return;
      const later = [...availablePages].filter(p => p > cur).sort((a,b) => a-b);
      const last = later.length ? later[later.length - 1] : cur;
      for (const nav of root.querySelectorAll('.lmm-pagination')) {
        for (const a of nav.querySelectorAll('a.lmm-pagination__link')) {
          const url = new URL(a.href, location.href);
          const p = Number(url.searchParams.get('page') || 1);
          if (a.classList.contains('lmm-pagination__next')) {
            if (later.length) {
              url.searchParams.set('page', String(later[0])); a.href = url.href;
            } else {
              const span = document.createElement('span');
              span.className = a.className + ' is-disabled';
              span.textContent = a.textContent; span.setAttribute('aria-disabled', 'true');
              a.replaceWith(span);
            }
          } else if (p > cur && !availablePages.has(p)) {
            a.closest('li').hidden = true;
          }
        }
        const currentLi = nav.querySelector('[aria-current="page"]')?.closest('li');
        if (last === cur && currentLi) for (const gap of nav.querySelectorAll('.lmm-pagination__gap')) {
          if (gap.closest('li').compareDocumentPosition(currentLi) & Node.DOCUMENT_POSITION_PRECEDING) gap.closest('li').hidden = true;
        }
      }
      marker.dataset.tailVerified = '1';
      marker.dataset.lastBuyablePage = String(last);
    } catch (_) {
      // Fail open: a network/index error must never make a restocked product unreachable.
      marker.dataset.tailVerified = '0';
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  document.addEventListener('lmm:content-swapped', init);
  document.addEventListener('shopify:section:load', init);
})();

/* Stock sorts (title-*) are sliced by Shopify before Liquid sorts them,
   so the whole (filtered) collection is pooled once and sliced client-side. */
(() => {
  if (window.__lmmStockSort) return;
  window.__lmmStockSort = true;

  const SORTS = { 'title-descending': -1, 'title-ascending': 1 };
  const MAX_PAGES = 25;
  const BATCH = 4;
  const POOL_TTL_MS = 300000;
  const SOURCE = 'lmm-stock-sort';
  const pools = new Map();
  let flight = null;

  const num = (v, d) => { const n = Number(v); return Number.isFinite(n) ? n : d; };
  const clamp = (n, lo, hi) => Math.min(hi, Math.max(lo, Math.trunc(n)));

  function signature(href) {
    const u = new URL(href || location.href, location.origin);
    ['page', 'sort_by', 'section_id', 'sections', '_cb'].forEach((k) => u.searchParams.delete(k));
    u.searchParams.sort();
    return u.pathname + '?' + u.searchParams;
  }

  function pageUrl(baseHref, sectionId, page) {
    const u = new URL(baseHref, location.origin);
    u.searchParams.delete('sections');
    u.searchParams.set('section_id', sectionId);
    u.searchParams.set('page', String(page));
    return u;
  }

  function cleanHtml(el) {
    const clone = el.cloneNode(true);
    clone.removeAttribute('data-pricebox');
    clone.querySelectorAll('.rowtotal').forEach((n) => n.remove());
    return clone.outerHTML;
  }

  function toItem(el) {
    return {
      id: clamp(num(el.getAttribute('data-product-id'), 0), 0, 999999999999999),
      acc: clamp(num(el.getAttribute('data-accessory'), 0), 0, 1),
      tier: clamp(num(el.getAttribute('data-stock-tier'), 3), 0, 3),
      qty: clamp(num(el.getAttribute('data-stock-qty'), 0), 0, 999999999),
      rank: clamp(num(el.getAttribute('data-rank-24m') ?? el.getAttribute('data-bestseller-rank'), 999999), 0, 999999),
      units: clamp(num(el.getAttribute('data-units-24m') ?? el.getAttribute('data-inv-units'), 0), 0, 99999999),
      buyable: el.getAttribute('data-buyable') === '1',
      html: cleanHtml(el)
    };
  }

  function extractDocItems(doc) {
    return Array.from(doc.querySelectorAll('#productList > article.prow[data-product-id]')).map(toItem);
  }

  // Direction-independent tie-break: a filtered view is the unfiltered order restricted to its subset.
  const compare = (dir) => (a, b) => (a.acc - b.acc) || (a.tier - b.tier)
    || (a.tier === 0 ? dir * (a.qty - b.qty) : 0)
    || (a.rank - b.rank) || (b.units - a.units) || (a.id - b.id);

  async function loadPool(baseHref, sectionId, pages, curPage, curItems, signal) {
    const pageItems = new Array(pages);
    if (curPage >= 1 && curPage <= pages && Array.isArray(curItems) && curItems.length) {
      pageItems[curPage - 1] = curItems;
    }
    const queue = [];
    for (let p = 1; p <= pages; p++) {
      if (!pageItems[p - 1]) queue.push(p);
    }
    let idx = 0;
    const worker = async () => {
      while (idx < queue.length) {
        const p = queue[idx++];
        const res = await fetch(pageUrl(baseHref, sectionId, p), { signal, credentials: 'same-origin' });
        if (!res.ok) throw new Error(`HTTP ${res.status} (page ${p})`);
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        const m = doc.querySelector('[data-lmm-stock-pagination]');
        if (!m || num(m.dataset.page, 0) !== p || num(m.dataset.pages, 0) !== pages) {
          throw new Error(`Pagination mismatch on page ${p}`);
        }
        pageItems[p - 1] = extractDocItems(doc);
      }
    };
    if (queue.length) await Promise.all(Array.from({ length: Math.min(BATCH, queue.length) }, worker));
    const seen = new Set();
    const items = [];
    pageItems.forEach((arr) => {
      if (!arr) throw new Error('Incomplete page pool');
      arr.forEach((it) => {
        if (!it.id || seen.has(it.id)) return;
        seen.add(it.id);
        items.push(it);
      });
    });
    return items;
  }

  function trimPager(root, cur, last) {
    for (const nav of (root || document).querySelectorAll('.lmm-pagination')) {
      for (const a of nav.querySelectorAll('a.lmm-pagination__link')) {
        const url = new URL(a.href, location.href);
        const p = num(url.searchParams.get('page'), 1);
        if (a.classList.contains('lmm-pagination__next')) {
          if (cur >= last) {
            const span = document.createElement('span');
            span.className = a.className + ' is-disabled';
            span.textContent = a.textContent;
            span.setAttribute('aria-disabled', 'true');
            a.replaceWith(span);
          }
        } else if (!a.classList.contains('lmm-pagination__prev') && p > last) {
          const li = a.closest('li');
          if (li) li.hidden = true;
        }
      }
      const currentLi = nav.querySelector('[aria-current="page"]')?.closest('li');
      if (last <= cur && currentLi) {
        for (const gap of nav.querySelectorAll('.lmm-pagination__gap')) {
          const gli = gap.closest('li');
          if (gli && (gli.compareDocumentPosition(currentLi) & Node.DOCUMENT_POSITION_PRECEDING)) gli.hidden = true;
        }
      }
    }
  }

  function getPool(sig, baseHref, sectionId, pages, curPage, curItems) {
    if (flight && flight.sig !== sig) { flight.ctrl.abort(); flight = null; }
    const cached = pools.get(sig);
    if (cached && (Date.now() - cached.ts) < POOL_TTL_MS) return cached.promise;
    if (cached) pools.delete(sig);
    const ctrl = new AbortController();
    flight = { sig, ctrl };
    const promise = loadPool(baseHref, sectionId, pages, curPage, curItems, ctrl.signal);
    const entry = { ts: Date.now(), promise };
    pools.set(sig, entry);
    const done = () => { if (flight && flight.ctrl === ctrl) flight = null; };
    promise.then(done, () => { if (pools.get(sig) === entry) pools.delete(sig); done(); });
    return promise;
  }

  async function run(marker) {
    const dir = SORTS[marker.dataset.sort];
    const list = document.getElementById('productList');
    const pages = num(marker.dataset.pages, 1);
    const sectionId = marker.dataset.section || marker.closest('.shopify-section')?.id?.replace(/^shopify-section-/, '');
    if (!dir || !list || pages <= 1 || pages > MAX_PAGES || !sectionId) {
      if (flight) { flight.ctrl.abort(); flight = null; }
      return;
    }
    const curItems = extractDocItems(document);
    if (!curItems.length) return;
    const baseHref = location.href;
    const sig = signature(baseHref);
    const cur = num(marker.dataset.page, 1);
    const size = num(marker.dataset.size, 60);
    const root = marker.closest('.lmm-coll') || document;
    marker.dataset.stockSorting = '1';
    list.setAttribute('data-stock-sort-busy', '1');
    list.setAttribute('aria-busy', 'true');
    try {
      const items = await getPool(sig, baseHref, sectionId, pages, cur, curItems);
      if (!marker.isConnected || !list.isConnected || signature(location.href) !== sig) return;
      const sorted = items.slice().sort(compare(dir));
      const slice = sorted.slice((cur - 1) * size, cur * size);
      if (!slice.length) return;
      list.innerHTML = slice.map((it) => it.html).join('');
      const offset = (cur - 1) * size;
      list.querySelectorAll(':scope > article.prow').forEach((row, idx) => {
        row.setAttribute('data-index', String(offset + idx + 1));
      });
      let lastBuyableIdx = -1;
      for (let i = sorted.length - 1; i >= 0; i--) {
        if (sorted[i].buyable && sorted[i].tier < 3) { lastBuyableIdx = i; break; }
      }
      const last = lastBuyableIdx >= 0 ? Math.max(1, Math.ceil((lastBuyableIdx + 1) / size)) : 1;
      trimPager(root, cur, last);
      marker.dataset.stockSorted = '1';
      marker.dataset.stockPoolTotal = String(sorted.length);
      marker.dataset.lastBuyablePage = String(last);
      document.dispatchEvent(new CustomEvent('lmm:cards-replaced', { detail: { root: list } }));
      document.dispatchEvent(new CustomEvent('lmm:content-swapped', { detail: { root: '#productList', source: SOURCE } }));
    } catch (e) {
      if (e.name !== 'AbortError') console.warn('[lmm-stock-sort]', e);
    } finally {
      delete marker.dataset.stockSorting;
      list.removeAttribute('data-stock-sort-busy');
      list.setAttribute('aria-busy', 'false');
    }
  }

  function init(e) {
    if (e && e.detail && e.detail.source === SOURCE) return;
    const exec = () => {
      const marker = document.querySelector('[data-lmm-stock-pagination]');
      if (!marker || marker.dataset.stockSorted === '1' || marker.dataset.stockSorting === '1') return;
      if (!SORTS[marker.dataset.sort]) { if (flight) { flight.ctrl.abort(); flight = null; } return; }
      run(marker);
    };
    if (e && e.type === 'lmm:content-swapped' && typeof Promise === 'function') {
      Promise.resolve().then(exec);
    } else {
      exec();
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('lmm:content-swapped', init);
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('pagehide', () => { if (flight) flight.ctrl.abort(); });
})();
